import { Component, AfterViewInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from 'src/app/_services/token-storage.service';
// Vue App von @n8n/chat – hat unmount() für sauberes Cleanup
import '@n8n/chat/style.css';
import { createChat } from '@n8n/chat';

/**
 * n8n Chat Widget – optimierte Einbindung gemäß @n8n/chat Dokumentation.
 * - User-Metadata für personalisierte n8n-Workflows
 * - Streaming für flüssigere Antworten (wenn Workflow unterstützt)
 * - Sauberes Cleanup beim Destroy
 */
@Component({
  selector: 'app-n8n-chat',
  templateUrl: './n8n-chat.component.html',
  styleUrls: ['./n8n-chat.component.css']
})
export class N8nChatComponent implements AfterViewInit, OnDestroy {
  private chatInstance: { unmount?: () => void } | null = null;
  @ViewChild('embed', { static: true }) embedRef?: ElementRef<HTMLElement>;

  constructor(private tokenStorage: TokenStorageService) {}

  ngAfterViewInit(): void {
    this.initChat();
  }

  ngOnDestroy(): void {
    if (this.chatInstance?.unmount) {
      try {
        this.chatInstance.unmount();
      } catch {
        // Fallback: DOM aufräumen falls unmount fehlschlägt
      }
    }
    const el = this.embedRef?.nativeElement;
    if (el) el.innerHTML = '';
    this.chatInstance = null;
  }

  private buildMetadata(): Record<string, unknown> {
    const metadata: Record<string, unknown> = {
      source: 'mh3_app',
      timestamp: new Date().toISOString(),
    };
    const currentUser = this.getCurrentUserFromStorage();
    const sessionUser = this.tokenStorage.getUser();
    const user = currentUser ?? sessionUser;
    if (user && (user.id || user.email || user.auth_user)) {
      metadata.userId = user.id;
      metadata.userEmail = user.email;
      metadata.userName = user.displayName ?? user.firstname ?? user.auth_user ?? user.name;
    }
    return metadata;
  }

  private getCurrentUserFromStorage(): Record<string, unknown> | null {
    try {
      const raw = localStorage.getItem('currentUser');
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  private initChat(): void {
    const webhookUrl = environment.n8nWebhookUrl;
    if (!webhookUrl) {
      console.error('n8nWebhookUrl ist nicht definiert.');
      return;
    }

    const enableStreaming = (environment as { n8nEnableStreaming?: boolean }).n8nEnableStreaming ?? false;

    this.chatInstance = createChat({
      webhookUrl,
      target: this.embedRef?.nativeElement ?? '#n8n-chat-embed',
      // Embedded im Customizer-Panel: echtes Chat-Layout mit Input unten
      mode: 'fullscreen',
      showWelcomeScreen: false,
      loadPreviousSession: true,
      enableStreaming,
      defaultLanguage: 'en',
      metadata: this.buildMetadata(),
      i18n: {
        en: {
          title: 'MH3 Assistent',
          subtitle: 'Antworten aus Ihrem n8n-Workflow.',
          footer: '',
          getStarted: 'Neue Unterhaltung',
          inputPlaceholder: 'Nachricht eingeben …',
          closeButtonTooltip: 'Schließen',
        },
      },
      initialMessages: [
        'Hallo! 👋',
        'Wie kann ich Ihnen helfen? Sie können mich z.B. zu Aufträgen, Lieferungen oder allgemeinen Fragen befragen.',
      ],
    });
  }
}
